import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import es from './es'

const messages = {
  en,
  es
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'es', // set locale
  messages // set locale messages
})
